import React, { useContext } from 'react'
import PropType from 'prop-types'

import { withStyles } from '@cred/react-theme'

import { fireGtmEvent } from 'utils/gtm'
import CtaButton from 'components/cta-button'
import WidgetContext from 'components/widget-context'
import PoweredBy from 'components/powered-by'
import getLayoutConfig from 'utils/getLayoutConfig'
import Nmls from 'components/nmls'

import defaultStyles from './styles.module.scss'
import wsj from './wsj.module.scss'
import copyOnlyConfig from './copyOnlyConfig'

const CopyOnlyRichCta = ({ href, title, body, ctaText, nmls, styles, theme }) => {
  const widgetContext = useContext(WidgetContext)

  const onClick = () => {
    fireGtmEvent('ctaClick', widgetContext)
  }

  const { Disclosures } = getLayoutConfig(theme, copyOnlyConfig)

  return (
    <div className={styles.widgetContainer}>
      <div className={styles.widget}>
        <div className={styles.copy}>
          <p className={styles.title}>{title}</p>
          <p className={styles.body}>{body}</p>
        </div>
        <div className={styles.cta}>
          <CtaButton
            data-testid="cta-button"
            className={styles.ctaButton}
            href={href}
            onClick={onClick}
            target="_blank"
            fullWidth
          >
            {widgetContext.richCta?.ctaTitle || ctaText}
          </CtaButton>
          <PoweredBy className={`mt-8 mt-sm-16 ${styles.poweredBy}`} />
          <Nmls show={nmls} />
        </div>
      </div>
      <Disclosures />
    </div>
  )
}

CopyOnlyRichCta.propTypes = {
  href: PropType.string.isRequired,
  title: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  nmls: PropType.bool,
  styles: PropType.object.isRequired,
  theme: PropType.string.isRequired,
}

export { CopyOnlyRichCta as CopyOnlyRichCtaNoHoc }

export default withStyles(defaultStyles, { wsj })(CopyOnlyRichCta)
